<script setup lang="ts">
import { ref } from 'vue'
import { SidebarTrigger } from '@/components/ui/sidebar'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from '@/components/ui/breadcrumb'
import { Separator } from '@/components/ui/separator'
import { useRoute } from 'vue-router'
import Button from '@/components/ui/button/Button.vue'
import DatePicker from '@/components/DatePicker.vue'
import AgencesPicker from '@/components/AgencesPicker.vue'

const route = useRoute()
const changesMade = ref(false)

const handleChanges = () => {
  changesMade.value = true
}

const refreshPage = () => {
  window.location.reload()
}
</script>

<template>
  <header class="flex shrink-0 items-center border-b">
    <div class="flex w-full my-4 items-center px-5">
      <!-- Colonne de gauche -->
      <div class="w-1/3 flex items-center gap-2">
        <SidebarTrigger />
        <Separator orientation="vertical" class="h-4" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem class="hidden xl:block">
              <BreadcrumbLink href="#" class="font-bold text-muted-foreground text-xl">
                {{ route.name }}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      <!-- Colonne centrale -->
      <div class="w-1/3 flex items-end justify-center gap-3">
        <AgencesPicker @change="handleChanges" />
        <DatePicker @change="handleChanges" />
        <Button v-if="changesMade" @click="refreshPage" variant="default">
          Valider mes changements
        </Button>
      </div>

      <!-- Colonne de droite (vide pour maintenir l'équilibre) -->
      <div class="w-1/3"></div>
    </div>
  </header>
</template>
